export const ossPrefix = 'https://terminus-emp.oss-cn-hangzhou.aliyuncs.com/aip/'